module.exports = __webpack_public_path__ + "static/media/service_details.f1fb599c.png";